module.exports = __webpack_public_path__ + "static/media/6.0af726b8.png";